export const paymentConfirmation = {
  extend: {
    directions: "",
    link: "Proceed to the next step",
  },
  generic: {
    directions: "",
    link: "Proceed to the next step",
  },
  payment: {
    directions:
      "Next, you’ll create a password for your account, and you’ll be all set!",
    link: "Set your password",
  },
  redirecting: "Redirecting you in ",
  resubscribe: {
    directions: "",
    link: "Proceed to the next step",
  },
  success: "Success",
  upgrade: {
    directions: "",
    link: "Proceed to the next step",
  },
};
